module.exports = __webpack_public_path__ + "img/471.181c8660.jpg";